<template>
    <div>
        <!-- summer banner -->
        <template v-if="!loading">
            <div class="col-9 m-auto skeleton-body skel-shop-products">
                <template>
                    <div
                        class="skel-pro skel-pro-list"
                        v-for="item in 1"
                        :key="item"
                    ></div>
                </template>
            </div>
        </template>
        <div class="" v-else>
            <section
                class="summer_sale text-center"
                v-for="(fourth, index) in banners.fourth"
                :key="index"
            >
                <a :href="fourth.button_link" v-if="$i18n.locale == 'en'">
                    <img v-lazy="fourth.background_image" />
                </a>
                <a :href="fourth.button_link" v-if="$i18n.locale == 'ar'">
                    <img v-lazy="fourth.background_image_ar" />
                </a>
                <!-- <div class="container">
                    <div class="row">
                        <div class="col mt-5">
                            
                            <h2 class="head hug text-white" >
                                {{ fourth.title }}
                            </h2>
                            
                            <h2
                                class="head hug text-white"
                                
                            >
                                {{ fourth.description }}
                            </h2>
                            <br />
                            <br />
                            <div class="row flex-column mt-4">
                            </div>
                        </div>
                        <div class="col"></div>
                    </div>
                </div> -->
            </section>
        </div>
    </div>
</template>

<script>
import Repository, { baseUrl } from '~/repositories/repository.js';

export default {
    data: function() {
        return {
            banners: {
                first: [],
                seconnd: [],
                third: [],
                fourth: [],
                fifth: [],
                sixth: [],
                seventh: []
            },
            loading: false
        };
    },
    methods: {
        getData: async function() {
            let banners = `${baseUrl}/banners`;

            // banners
            await Repository.get(banners).then(resp => {
                //banners
                if (resp.data.code == 200) {
                    this.loading = true;
                }
                this.banners = resp.data.banners;
                // console.log('banners', this.banners);
            });
        }
    },
    mounted() {
        this.getData();
    },
    props: ['product']
};
</script>

<style></style>
